'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Extracts a styles object with only props that contain function values.
 */
exports['default'] = function (styles) {
  var fnValuesCounter = 0;

  // eslint-disable-next-line no-shadow
  function extract(styles) {
    var to = void 0;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
        fnValuesCounter++;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        if (!to) to = {};
        var _extracted = extract(value);
        if (_extracted) to[key] = _extracted;
      }
    }

    return to;
  }

  var extracted = extract(styles);
  return fnValuesCounter ? extracted : null;
};


// WEBPACK FOOTER //
// ./~/jss/lib/utils/getDynamicStyles.js